import { HISTORIAL_TYPES } from '../constants/historial.types'

import { historialInitialState } from '../initital-state/historial.state'
import { HistorialAction, HistorialFacturacion, HistorialState } from '../interfaces/historial.interface'

const historialReducer = (
  state: HistorialFacturacion = historialInitialState,
  action: HistorialAction
): HistorialState => {
  switch (action.type) {
    // FILTRO -----------------------------------------------------------------------
    case HISTORIAL_TYPES.HISTORIAL_SAVE_SEARCH_FORMFILTER:
      return {...state, searchFormFilter: {...state.searchFormFilter, ...action.payload}}
    case HISTORIAL_TYPES.HISTORIAL_SET_ACTIVE_PAGE:
      return {...state, numPagina: action.payload}
    case HISTORIAL_TYPES.HISTORIAL_SET_TOTALS_PAGES:
    return {...state, totalPaginas: action.payload}
    case HISTORIAL_TYPES.HISTORIAL_FORMFILTER_CHANGE:
      return {...state, formFilter: {...state.formFilter, ...action.payload}}
    case HISTORIAL_TYPES.HISTORIAL_SET_ERRORS_FILTER:
      return {...state, errorsFilter: {...state.errorsFilter, ...action.payload}}
    // MODALS -----------------------------------------------------------------------
    case HISTORIAL_TYPES.HISTORIAL_MODAL_ANULAR_STATUS:
      return {...state, modals: {...state.modals, activeAnular: action.payload}}
    case HISTORIAL_TYPES.HISTORIAL_MODAL_EMAIL_STATUS:
      return {...state, modals: {...state.modals, activeEnvioCorreo: action.payload}}
    case HISTORIAL_TYPES.HISTORIAL_MODAL_OPTIONS_STATUS:
      return {...state, modals: {...state.modals, activeOpciones: action.payload}}
    case HISTORIAL_TYPES.HISTORIAL_MODAL_PRINT_STATUS:
      return {...state, modals: {...state.modals, activePrint: action.payload, ...(!action.payload && {modoTicketPrint: false})}}
    case HISTORIAL_TYPES.HISTORIAL_MODAL_PRINT_TICKET_MODE:
      return {...state, modals: {...state.modals, modoTicketPrint: action.payload}}
    // GENERAL ----------------------------------------------------------------------
    case HISTORIAL_TYPES.HISTORIAL_SET_ITEMS_ANULAR:
      return {...state, itemsAnular: action.payload}
    case HISTORIAL_TYPES.HISTORIAL_SET_TIPOS_DOCS:
      return {...state, tiposDocumentos: action.payload}
    case HISTORIAL_TYPES.HISTORIAL_SET_ACTIVE_FACTURA:
      return {...state, activeFactura: action.payload}
    case HISTORIAL_TYPES.HISTORIAL_ARRAYRESULTADO:
      return {...state, arrayFacturas: action.payload}
    case HISTORIAL_TYPES.HISTORIAL_SET_QR:
      return {...state, qrFactura: action.payload}
    case HISTORIAL_TYPES.HISTORIAL_SET_ANULADO:
      return {...state, anulado: action.payload}
    case HISTORIAL_TYPES.HISTORIAL_SET_RESULT_ANULACIONES:
      return {...state, resultAnulaciones: action.payload}
    // REINICIAR -------------------------------------------------------------------
    case HISTORIAL_TYPES.HISTORIAL_RESET_ALL:
      return historialInitialState;
    default:
      return state
  }
}

export default historialReducer
